module.exports = __webpack_public_path__ + "img/源汇区-c.60e53c5d.png";